import {
  LoginApi,
  CustomerLoginApi,
  CustomerSignupApi,
  OtpVerifyApi,
  ResetPasswordApi,
  UserLogoutApi,
  getUserProfile,
  RefreshTokenApi,
  VerifySingupNo,
  VerifySingupOTP,
} from '../../../routes/apiRoutes';
import { axiosPost, axiosGet, authAPIInstance } from '../commonApis';

export const handleLogin = async (loginData) => {
  return await authAPIInstance.post(LoginApi, loginData);
};

export const handleCustomerLogin = async (loginData) => {
  return await authAPIInstance.post(CustomerLoginApi, loginData);
};

export const handleCustomerSignup = async (signupData) => {
  return await authAPIInstance.post(CustomerSignupApi, signupData);
};

export const handleCustomerSignupNo = async (signupNo) => {
  return await authAPIInstance.post(VerifySingupNo, signupNo);
};

export const handleCustomerOTPVerify = async (verifyData) => {
  return await authAPIInstance.post(VerifySingupOTP, verifyData);
};

export const handleCustomerSigninVerify = async (verifyData) => {
  return await authAPIInstance.post(OtpVerifyApi, verifyData);
};
export const handleCustomerSigninOTPVerify = async (verifyData) => {
  return await authAPIInstance.post(VerifySingupOTP, verifyData);
};

export const handleSendOTP = async (data) => {
  return await authAPIInstance.post(ResetPasswordApi, data);
};

export const handlePasswordReset = async (data) => {
  return await authAPIInstance.post(ResetPasswordApi, data);
};

export const handleLogout = async (token = '') => {
  const response = await axiosGet(UserLogoutApi, token);
  return response.data;
};

export const handleGetUserProfile = async (token) => {
  const response = await axiosGet(getUserProfile, token);
  return response.data;
};

export const handleRefreshToken = () => {
  return async () => {
    const response = await axiosPost(RefreshTokenApi);
    return response.data;
  };
};
